<template>
    <div class="saveOrUpdateCrud margin-10-10-0">
        <div>
            <el-page-header @back="close" content="查看学生信息导入表"></el-page-header>
        </div>
        <el-form :model="upsertForm"   :inline="true" label-width="80px" style="margin-top: 20px;" >
            <div style="border: dashed 1px #1989FA;height: 250px">
                <div style="height: 30px;">
                    <el-alert title="基础信息" type="success" :closable="false"></el-alert>
                </div>
                <div style="margin-top: 10px">
                    <div style="width: 25%;float: left">
                        <el-form-item label="照片">
                            <img v-if="upsertForm.faceImg" :src="config.resPre+upsertForm.faceImg" class="uploader-img">
                        </el-form-item>
                    </div>
                    <div style="width: 75%;float: left" class="longLabeles">
                        <el-form-item label="考生姓名">
                            <el-input size="mini" readonly v-model="upsertForm.name" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号">
                            <el-input size="mini" readonly v-model="upsertForm.idCard" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="出生日期">
                            <el-input size="mini" readonly  v-model="upsertForm.birthday" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="性别">
                            <el-input size="mini" readonly  v-model="upsertForm.sex" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="民族">
                            <el-input size="mini" readonly  v-model="upsertForm.nation" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="政治面貌">
                            <el-input size="mini" readonly  v-model="upsertForm.politicalAffiliation" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="家庭住址">
                            <el-input size="mini" readonly  v-model="upsertForm.homeAddress" auto-complete="off"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div style="border: dashed 1px #1989FA;height: 140px;margin-top: 10px" class="phoneLabel">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="联系电话" type="success" :closable="false"></el-alert>
                </div>
                <el-form-item label="联系电话">
                    <el-input size="mini" readonly v-model="upsertForm.phone" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮编">
                    <el-input size="mini" readonly v-model="upsertForm.adressCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系地址">
                    <el-input size="mini" readonly  style="width: 410px" v-model="upsertForm.address" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="户籍所在地" prop="permanentAddress">
                    <el-input size="mini" readonly style="width: 410px" v-model="upsertForm.permanentAddress" auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <div style="border: dashed 1px #1989FA;height: auto;margin-top: 10px" class="longLabel">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="报考情况" type="success" :closable="false"></el-alert>
                </div>
                <el-form-item label="毕业学校">
                    <el-input size="mini" readonly v-model="upsertForm.univerColleges" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="毕业专业">
                    <el-input size="mini" readonly v-model="upsertForm.studyMajor" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考学校">
                    <el-input size="mini" readonly v-model="upsertForm.studyColleges" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考学校代码">
                    <el-input size="mini" readonly v-model="upsertForm.studyCollegesCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考专业">
                    <el-input size="mini" readonly  v-model="upsertForm.examMajor" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="报考专业代码">
                    <el-input size="mini" readonly  v-model="upsertForm.examMajorCode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="考生类型" prop="studentType">
                    <el-input size="mini" readonly  v-model="upsertForm.studentType" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="建档立卡所在省" prop="archivesCardProvince" v-if="upsertForm.studentType && upsertForm.studentType=='建档立卡'">
                    <el-input size="mini" readonly  v-model="upsertForm.archivesCardProvince" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="入伍时间" prop="joinArmyTime" v-if="upsertForm.studentType && upsertForm.studentType=='退役士兵'">
                    <el-input size="mini" maxlength="32" placeholder="请输入入伍时间"  show-word-limit  v-model="upsertForm.joinArmyTime" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="退役时间" prop="endArmyTime" v-if="upsertForm.studentType && upsertForm.studentType=='退役士兵'">
                    <el-input size="mini" maxlength="32" placeholder="请输入退役时间"  show-word-limit  v-model="upsertForm.endArmyTime" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="退役安置地" prop="endArmyAdress" v-if="upsertForm.studentType && upsertForm.studentType=='退役士兵'">
                    <el-input size="mini" maxlength="255" placeholder="请输入退役安置地"  show-word-limit  v-model="upsertForm.endArmyAdress" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="入学时间" prop="startStudyTime">
                    <el-input size="mini" readonly  v-model="upsertForm.startStudyTime" placeholder="请输入入学时间" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="毕业时间" prop="endStudyTime">
                    <el-input size="mini" readonly v-model="upsertForm.endStudyTime" placeholder="请输入毕业时间" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="毕业生类型" prop="graduatesType">
                    <el-input size="mini" readonly  v-model="upsertForm.graduatesType" placeholder="请输入毕业生类型" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="入伍地" prop="enlistmentPlace">
                    <el-input size="mini" readonly  v-model="upsertForm.enlistmentPlace" placeholder="请输入入伍地" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="入伍类型" prop="enlistmentType">
                    <el-input size="mini" readonly v-model="upsertForm.enlistmentType" placeholder="请输入入伍类型" auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <div style="border: dashed 1px #1989FA;height: 200px;margin-top: 10px" class="longLabels">
                <div style="height: 30px;margin-bottom: 8px">
                    <el-alert title="其它信息" type="success" :closable="false"></el-alert>
                </div>
                <el-form-item label="所获奖励">
                    <el-input size="mini" readonly type="textarea" autosize resize="none" style="width: 1020px" v-model="upsertForm.reward" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="特长">
                    <el-input size="mini"readonly type="textarea" autosize resize="none" style="width: 1020px" v-model="upsertForm.speciality" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input size="mini" readonly type="textarea" autosize resize="none" style="width: 1020px" v-model="upsertForm.remark" auto-complete="off"></el-input>
                </el-form-item>
            </div>
        </el-form>
        <div  class="dialog-footer" style="text-align: center;">
            <el-button plain class="large" size="mini" @click="close">取 消</el-button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "lookSysStudentIn",
        props: ['id'],
        data(){
            return {
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    faceImg:'',
                    name:'',
                    studentType:'',
                    birthday:'',
                    sex:'',
                    nation:'',
                    politicalAffiliation:'',
                    idCard:'',
                    archivesCardProvince:'',
                    univerColleges:'',
                    studyMajor:'',
                    studyColleges:'',
                    studyCollegesCode:'',
                    examMajor:'',
                    examMajorCode:'',
                    homeAddress:'',
                    address:'',
                    adressCode:'',
                    phone:'',
                    reward:'',
                    speciality:'',
                    endSchoolCode:'',
                    joinArmyTime:'',
                    endArmyTime:'',
                    endArmyCode:'',
                    endArmyAdress:'',
                    year:'',
                    permanentAddress:'',
                    startStudyTime:'',
                    endStudyTime:'',
                    graduatesType:'',
                    enlistmentPlace:'',
                    enlistmentType:'',
                    updateTime:'',
                    createTime:''
                },
                config:config
            }
        },
        created(){
          axios({
                url:`${home}/sysStudentIn/look/lookSysStudentInById/${this.id}`,
                method:'GET'
            }).then(res=>{
                Object.assign(this.upsertForm,res.data);
            }).catch(error=>{
                console.log(error);
            })
        },
        mounted(){

        },
        methods:{
            close(){
                this.$emit('update:visible');
            }
        }
    }
</script>

<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }
</style>
<style lang="scss">
    .longLabeles{
        .el-input__inner{
            width: 340px;
        }
    }
    .longLabel{
        .el-form-item__label{
            width: 110px !important;
        }
        .el-input__inner{
            width: 265px;
        }
    }
    .longLabels{
        .el-form-item__label{
            width: 120px !important;
        }
    }
    .phoneLabel{
        .el-form-item__label{
            width: 120px !important;
        }
    }
</style>